import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/channel/page',
  ADD: '/dh-datamaint/channel/add',
  DELETE: '/dh-datamaint/channel/delete',
  DETAIL: '/dh-datamaint/channel/getById',
  UPDATE: '/dh-datamaint/channel/update',
  GET_SORT: '/dh-datamaint/channel/count',
  SORT: '/dh-datamaint/channel/sort',
  LIST: '/dh-datamaint/channel/listAll'
};

class ChannelModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async Sort(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async getChannelList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.LIST, { params: payload.data });
    }
  };
}

export const channelModule = new ChannelModule();
